export const MigrationTypes = {
  IMAGE: 'IMAGE',
  RICH_TEXT: 'RICH_TEXT',
  BUTTON: 'BUTTON',
  HTML: 'HTML'
};
export const CTAS_URL = 'ctas/v3';
export const PLACEMENTS_URL = `${CTAS_URL}/placements`;
export const DEPENDENCY_URL = `${PLACEMENTS_URL}/dependencies`;
export const MIGRATION_URL = `${CTAS_URL}/legacy-migration`;